import axios from "axios";
import jwtService from "./jwt.service";

export default () => {
  const token = jwtService.getToken();
  const headers = {
    // "Content-Type": "application/json",
    Accept: "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  axios.defaults.headers = headers;

  return axios.create({
    baseURL: process.env.API_BASE_URL,
    headers,
  });
};
